import gameState from 'client/game_orderReward/redux/modules/gameState';

export default {
    gameState
};
